<template lang="pug">
li.list-inline-item.dropdown.notification-list#waiting(v-if="line")
  span.nav-link
    i.mdi.mdi-timer-sand
    span.badge.badge-pink.noti-icon-badge(v-if="line" v-text="total")
</template>

<script>
import Lib from '@/lib'
export default {
  data() {
    return {
      tasks: {},
    }
  },
  computed: {
    total() {
      return this.tasks.waiting + this.tasks.processing;
    },
    line() {
      return this.total > 0;
    },
    longLine() {
      return this.total > 10;
    },
    vacant() {
      return this.total == 0;
    },
  },
  created() {
    const app = new Lib.App();
    app.getQueuedTasks().then(tasks => this.tasks = tasks);
    setInterval(() => {
      app.getQueuedTasks().then(tasks => { this.tasks = tasks});
    }, 5 * 1000);
  },
}
</script>